<template>
    <div v-if="isDesktop">
        <div v-if="show" id="pop-up-outgoing">
            <CloseButton class="ico-close-modal" @click="hideOutgoing()" />
            <a :href="popUp.ctaUrl" target="_blank" @click="clickCta()">
                <img :src="popUp.imageUrl" loading="lazy" :alt="popUp.title" />
            </a>
        </div>
        <div v-if="showBox">
            <button class="pop-up-outgoing__close-box d-flex" @click="showOutgoing()">
                <div class="mt-1" v-html="popUp.title"></div>
                <div class="ico ico-open-modal"></div>
            </button>
        </div>
    </div>
    <div v-else-if="!isDesktop && show" id="pop-up-mobile-outgoing">
        <CloseButton class="ico-close-modal" @click="hideOutgoing()" />
        <a :href="popUp.ctaUrl" target="_blank" @click="clickCta()">
            <img :src="popUp.mobileImageUrl" loading="lazy" :alt="popUp.title" />
        </a>
    </div>
</template>

<script lang="ts" setup>
import { useCookie } from '#imports'
import PopUpOutgoing from '~/models/StaticContent/PopUpOutgoing'
import DataLayer from '~/extensions/DataLayer'
import GtmEventActions from '~/value/GtmEventActions'
import CloseButton from '~/components/ui/CloseButton.vue'

const props = defineProps({
    popUp: {
        type: Object as PropType<PopUpOutgoing>,
        required: true,
    },
    isDesktop: {
        type: Boolean,
        default: true,
    },
})
const show = ref(false)
const showBox = ref(false)

const clickCta = () => {
    DataLayer.push({
        event: 'slide_modal',
        action: GtmEventActions.CLICK,
        pop_up_name: props.popUp.title,
        page_url: location.href,
        landing_page: props.popUp.ctaUrl,
    })
}

const hideOutgoing = () => {
    show.value = false
    showBox.value = true
    setTimeout(() => {
        const el = document.getElementById('pop-up-outgoing')
        if (el) {
            el.classList.remove('show')
        }

        DataLayer.push({
            event: 'slide_modal',
            action: GtmEventActions.CLOSE,
            pop_up_name: props.popUp.title,
            page_url: location.href,
            landing_page: props.popUp.ctaUrl,
        })
    })
}

const showOutgoing = (eventOpenType = 'onClick') => {
    show.value = true
    showBox.value = false

    setTimeout(() => {
        const el = document.getElementById('pop-up-outgoing')
        if (el) {
            el.classList.add('show')
        }

        DataLayer.push({
            event: 'slide_modal',
            action: GtmEventActions.OPEN,
            type: eventOpenType,
            pop_up_name: props.popUp.title,
            page_url: location.href,
            landing_page: props.popUp.ctaUrl,
        })
    })
}

const leftViews = () => {
    const cookieName = 'popUp' + props.popUp.id
    const popUpData = useCookie<{ leftViews: number; expirationDate: string } | undefined>(cookieName).value

    if (popUpData === undefined) {
        const maxViews = 1
        const date = new Date()
        date.setHours(date.getHours() + 24)

        useCookie(cookieName, { expires: date }).value = JSON.stringify({
            leftViews: maxViews - 1,
            expirationDate: date,
        })

        return true
    } else if (popUpData.leftViews !== 0) {
        useCookie(cookieName, { expires: new Date(Date.parse(popUpData.expirationDate)) }).value = JSON.stringify({
            leftViews: popUpData.leftViews - 1,
            expirationDate: popUpData.expirationDate,
        })

        return true
    }

    return false
}

onMounted(() => {
    if (leftViews()) {
        setTimeout(
            () => {
                showOutgoing('onSlide')
            },
            props.isDesktop ? 3000 : 0
        )
    } else {
        showBox.value = true
    }
})
</script>

<style lang="scss">
#pop-up-outgoing {
    position: fixed;
    left: auto;
    right: 15px;
    bottom: 15px;
    width: 300px;
    height: 300px;
    display: block;
    z-index: 10;
    transition: transform 1s ease;
    transform: translateX(110%);
}

#pop-up-outgoing.show {
    transform: translateX(0);
}

#pop-up-mobile-outgoing {
    position: fixed;
    display: block;
    z-index: 10;
    left: 50%;
    bottom: 70px;
    transform: translate(-50%);
    width: 100%;
}

.pop-up-outgoing__close-box {
    position: fixed;
    overflow: visible;
    opacity: 1;
    border: 0;
    z-index: 10;
    transition-duration: 250ms;
    transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
    transition-property: opacity, top, bottom;
    padding: 12px 14px 12px 14px;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 600;
    background: rgba(255, 244, 242, 1);
    color: #000;
    box-shadow: 0 0 11px 0 rgba(0, 0, 0, 0.17);
    cursor: pointer;
    bottom: 5%;
    left: 1%;
}

.ico-open-modal {
    background: url('/nuxt-assets/images/icons/popUp/right-pink-arrow.svg') no-repeat 50%;
    background-size: contain;
    display: inline-block;
    min-height: 24px;
    min-width: 24px;
    margin-left: 10px !important;
}

.ico-close-modal {
    background-color: $color-grey-dark;
    display: block;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10;
    opacity: 0.7;
    padding: 5px !important;

    &:hover {
        opacity: 0.9;
    }
}
</style>
